module.exports = __webpack_public_path__ + "assets/img/slat_open3.3700222c.svg";